import { JOGGResponse } from "@jog/types"

import { JoggApiOption } from "./client"

export const removePaymentCostBase =
    ({ execute }: Pick<JoggApiOption, "execute">) =>
    async (cartId: string, version: number, customLineItemId: string): Promise<JOGGResponse<void>> =>
        execute({
            uri: `/ctp/carts/${cartId}`,
            method: "POST",
            body: { version, actions: [{ action: "removeCustomLineItem", customLineItemId }] },
        })
